export default __webpack_public_path__ + "static/media/googlePlay.ca74d714.svg";